// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.themes {
  display: grid;
  gap: 1rem;
}

.theme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 1fr));
  gap: 1.5rem 1.25rem;
}

.theme-card {
  display: grid;
  gap: 0.6rem;
  min-width: 0;
}

.theme-image {
  display: block;
  width: 100%;
  min-height: 0;
  padding: 0;
  background: #050808;
  border: 1px solid var(--border-primary);
  cursor: zoom-in;
  overflow: hidden;
}

.theme-image img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.theme-image:hover img {
  transform: scale(1.03);
}

.theme-body {
  display: grid;
  gap: 0.4rem;
  min-width: 0;
}

.theme-name {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
}

.theme-string-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.theme-string {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  font-size: 0.8rem;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  user-select: all;
}

.theme-string::-webkit-scrollbar {
  display: none;
}

.theme-copy {
  flex-shrink: 0;
  min-height: 38px;
  padding: 0.4rem 0.7rem;
}

.theme-copy.done {
  background: var(--accent-primary);
  color: var(--on-accent);
}

/* Großansicht */
.theme-preview {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgba(5, 8, 8, 0.85);
}

.theme-preview figure {
  margin: 0;
  display: grid;
  gap: 0.5rem;
  max-width: min(36rem, 100%);
}

.theme-preview img {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  height: auto;
  margin: 0 auto;
}

.theme-preview figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: #f2f5f4;
  font-family: var(--font-display);
  font-size: 1.2rem;
  text-transform: uppercase;
}

.theme-preview .icon-btn {
  color: #f2f5f4;
  border-color: rgba(242, 245, 244, 0.4);
}

@media (max-width: 680px) {
  .theme-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.25rem 0.75rem;
  }

  .theme-name {
    font-size: 1rem;
  }

  .theme-string-row {
    flex-direction: column;
    align-items: stretch;
  }

  .theme-string {
    font-size: 0.7rem;
  }

  .theme-copy {
    justify-content: center;
  }
}

/* Hinweise über dem Theme-Raster */
.theme-notes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 22rem), 1fr));
  gap: 0 1.5rem;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ColorThemes/ColorThemes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sEAAsE;EACtE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".themes {\n  display: grid;\n  gap: 1rem;\n}\n\n.theme-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 1fr));\n  gap: 1.5rem 1.25rem;\n}\n\n.theme-card {\n  display: grid;\n  gap: 0.6rem;\n  min-width: 0;\n}\n\n.theme-image {\n  display: block;\n  width: 100%;\n  min-height: 0;\n  padding: 0;\n  background: #050808;\n  border: 1px solid var(--border-primary);\n  cursor: zoom-in;\n  overflow: hidden;\n}\n\n.theme-image img {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.theme-image:hover img {\n  transform: scale(1.03);\n}\n\n.theme-body {\n  display: grid;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.theme-name {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.theme-string-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.theme-string {\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  white-space: nowrap;\n  scrollbar-width: none;\n  font-size: 0.8rem;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  user-select: all;\n}\n\n.theme-string::-webkit-scrollbar {\n  display: none;\n}\n\n.theme-copy {\n  flex-shrink: 0;\n  min-height: 38px;\n  padding: 0.4rem 0.7rem;\n}\n\n.theme-copy.done {\n  background: var(--accent-primary);\n  color: var(--on-accent);\n}\n\n/* Großansicht */\n.theme-preview {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: grid;\n  place-items: center;\n  padding: 1rem;\n  background: rgba(5, 8, 8, 0.85);\n}\n\n.theme-preview figure {\n  margin: 0;\n  display: grid;\n  gap: 0.5rem;\n  max-width: min(36rem, 100%);\n}\n\n.theme-preview img {\n  display: block;\n  max-width: 100%;\n  max-height: 80vh;\n  height: auto;\n  margin: 0 auto;\n}\n\n.theme-preview figcaption {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  color: #f2f5f4;\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  text-transform: uppercase;\n}\n\n.theme-preview .icon-btn {\n  color: #f2f5f4;\n  border-color: rgba(242, 245, 244, 0.4);\n}\n\n@media (max-width: 680px) {\n  .theme-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1.25rem 0.75rem;\n  }\n\n  .theme-name {\n    font-size: 1rem;\n  }\n\n  .theme-string-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .theme-string {\n    font-size: 0.7rem;\n  }\n\n  .theme-copy {\n    justify-content: center;\n  }\n}\n\n/* Hinweise über dem Theme-Raster */\n.theme-notes {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 22rem), 1fr));\n  gap: 0 1.5rem;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
